// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/GreycliffCF-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/GreycliffCF-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/GreycliffCF-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/GreycliffCF-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/GreycliffCF-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/GreycliffCF-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --theme: #071E31;
  --themeDark: #1D1E24;
  --themelight: #ffffff;
  --themeSuccess: #16c748;
  --themeDanger: #ff3030; 
}

@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Visby Round CF Demi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Visby Round CF Extra';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

body {
  font-family: 'Greycliff CF' !important;
  width: 100% !important;
  margin: 0;
  padding: 0;
  background-color: #fff !important;
}
.imergey-layout {
  background: #fff;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
span,
*,
a {
  font-family: 'Greycliff CF' !important;
}

ul {
  padding: 0px !important;
  margin: 0px !important;
  list-style: none;
}

/* Scroll-reveal (used by the <Reveal> wrapper on the homepage) */
.reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}
.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}
@media (prefers-reduced-motion: reduce) {
  .reveal {
    transition: none;
    opacity: 1;
    transform: none;
  }
}
 
nav.header-main {
  background: #F2F8FF;
  padding: 10px 30px;
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  border-bottom: 1px solid transparent;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, backdrop-filter 0.3s ease, border-color 0.3s ease;
}
nav.header-main.header-main-scrolled {
  background: rgba(242, 248, 255, 0.72);
  backdrop-filter: blur(14px) saturate(160%);
  -webkit-backdrop-filter: blur(14px) saturate(160%);
  box-shadow: 0 8px 28px -12px rgba(7, 30, 49, 0.18);
  border-bottom-color: rgba(7, 30, 49, 0.06);
}
.logo-image img {
  height: 38px;
  width: auto;
  display: block;
}

/* ── sticky mini "Book a Demo" CTA — fades/slides in once the hero is scrolled past ── */
.header-mini-cta {
  margin-left: 22px;
  flex-shrink: 0;
  align-items: center;
  background: linear-gradient(135deg, #071E31 0%, #3B6B94 100%);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  border: none;
  border-radius: 999px;
  padding: 10px 20px;
  cursor: pointer;
  box-shadow: 0 8px 20px -8px rgba(7, 30, 49, 0.5);
  opacity: 0;
  transform: translateY(-8px) scale(0.9);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;
}
.header-mini-cta.header-mini-cta-in {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}
.header-mini-cta:hover {
  box-shadow: 0 12px 26px -8px rgba(59, 107, 148, 0.6), 0 0 0 3px rgba(108, 229, 232, 0.18);
  transform: translateY(-1px) scale(1.02);
}
@media (prefers-reduced-motion: reduce) {
  .header-mini-cta { transition: opacity 0.2s ease; transform: none !important; }
}
button.menu-toggle svg {
  width: 40px;
  height: 40px;
}
button.menu-toggle {
  width: 40px;
  padding: 0px;
  height: auto;
}
.mobile-menu.nav {
  gap: 16px;
  text-align: left !important;
}
.mobile-menu.nav a.menu-link.nav-link { 
  padding: 10px !important;  
  border-bottom: 1px solid #cccccc61;
}
.mobile-menu.nav a.menu-link.active {
  font-weight: 700;
  background-color: #071E31;
  color: #fff !important;
}
.ant-drawer-content.mobile-menu-drawer .ant-drawer-header.ant-drawer-header-close-only {
  background-color: #3B6B94;
}
.ant-drawer-content.mobile-menu-drawer button.ant-drawer-close {
  color: #fff !important;
  font-size: 22px !important;
}
#whoweare, #whatwedo, #howitwork, #insights, #faq {
  scroll-margin-top: 50px;
}
.ant-drawer-content-wrapper {
  top: 60px !important;
}
a.menu-link.nav-link {
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #071E31 !important;
  padding: 0px !important;
}
a.menu-link.active  {
  font-weight: 700;
}
.navbar-menu.navbar-nav {
  gap: 20px;
}
button.ant-btn.fill-btn {
  background: #3B6B94;
  min-width: 130px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  min-height: 38px;
  border: 1px solid #3B6B94;
  border-radius: 8px;
}
button.ant-btn.outline-btn {
  background: transparent;
  min-width: 130px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--themeDark);
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  min-height: 38px;
  border-radius: 8px;
  border:  1px solid #071E311A;
}
.header-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}
section.hero-section {
  padding: 56px 0px 32px;
  position: relative;
  overflow: hidden;
}
.hero-grid-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image:
    linear-gradient(rgba(7, 30, 49, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 30, 49, 0.05) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 30%, #000 0%, transparent 75%);
}
section.hero-section .hero-banner-shape {
  position: absolute;
  right: 0;
  bottom: 35%;
  z-index: 0;
}
.hero-banner-shape img{
  max-width: 450px;
  width: 100%;
  animation: ime-float-shape 6s ease-in-out infinite;
}
@keyframes ime-float-shape {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-18px); }
}
@media (prefers-reduced-motion: reduce) {
  .hero-banner-shape img {
    animation: none;
  }
}
h1.hero-title {
  font-weight: 700;
  font-size: clamp(28px, 3.4vw, 40px);
  line-height: 1.4;
  text-align: center;
  text-transform: uppercase;
  color: var(--themeDark);
  margin: 0;
}
h1.hero-title span{
  color: #3B6B94;
}
p.hero-subtitle {
  color: var(--themeDark);
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
  letter-spacing: 0%;
  text-align: center;
}
.platform-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  position: relative;
}
.platform-preview .browser-frame {
  max-width: 660px;
}

/* Real product screenshots, framed as a browser window so it's obvious
   these aren't stock photography. */
.browser-frame {
  width: 100%;
  margin: 0 auto;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 30px 60px -20px rgba(7, 30, 49, 0.35), 0 0 0 1px rgba(7, 30, 49, 0.06);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease;
}
.platform-preview .browser-frame:hover,
.dashboard-preview .browser-frame:hover {
  transform: translateY(-6px);
  box-shadow: 0 40px 70px -20px rgba(7, 30, 49, 0.4), 0 0 0 1px rgba(7, 30, 49, 0.06);
}
.browser-frame .browser-frame-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: #EEF2F7;
  border-bottom: 1px solid #E1E7EF;
}
.browser-frame .browser-frame-dots {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.browser-frame .browser-frame-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
}
.browser-frame .browser-frame-dots span:nth-child(1) { background: #FF5F57; }
.browser-frame .browser-frame-dots span:nth-child(2) { background: #FEBC2E; }
.browser-frame .browser-frame-dots span:nth-child(3) { background: #28C840; }
.browser-frame .browser-frame-url {
  flex: 1 1;
  max-width: 320px;
  margin: 0 auto;
  background: #E8EDF3;
  border: 1px solid #D8DFE8;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 12px;
  color: #9BA8B5;
  text-align: center;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  letter-spacing: 0.01em;
}
.browser-frame img.browser-frame-shot {
  display: block;
  width: 100%;
}
.hero-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
button.ant-btn.trial-btn {
  background: #071E31;
  max-width: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  min-height: 50px;
  border: 1px solid #071E31;
  border-radius: 8px;
  box-shadow: 0 14px 30px -10px rgba(7, 30, 49, 0.55);
  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease, color 0.25s ease;
}
button.ant-btn.trial-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 34px -10px rgba(7, 30, 49, 0.4);
}
button.ant-btn.trial-btn:hover  , button.ant-btn.fill-btn:hover{
  background: #fff !important;
  color: #071E31 !important;
  border: 1px solid #071E31 !important;
}
button.ant-btn.outline-btn:hover {
  background: #fff !important;
  color: #071E31 !important;
  border: 1px solid #071E31 !important;
}

button.ant-btn.demo-btn {
  background: linear-gradient(180deg, #ffffff 0%, #f4f9fc 100%);
  max-width: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9px;
  color: #071E31;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  min-height: 50px;
  border: 2px solid #3B6B94;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 26px -14px rgba(59, 107, 148, 0.6);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}
button.ant-btn.demo-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(108, 229, 232, 0.22) 0%, rgba(59, 107, 148, 0.06) 100%);
  opacity: 0;
  transition: opacity 0.25s ease;
}
button.ant-btn.demo-btn .demo-btn-icon {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
button.ant-btn.demo-btn span:not(.demo-btn-icon) {
  position: relative;
}
button.ant-btn.demo-btn:hover {
  transform: translateY(-2px);
  border-color: #6CE5E8;
  box-shadow: 0 18px 36px -12px rgba(59, 107, 148, 0.55), 0 0 0 4px rgba(108, 229, 232, 0.14);
}
button.ant-btn.demo-btn:hover::before { opacity: 1; }
.features-container {
  background: var(--theme);
  border-radius: 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 36px 44px;
  margin-top: 70px;
  position: relative;
  overflow: hidden;
}
.features-container::after {
  content: '';
  position: absolute;
  right: -90px;
  bottom: -160px;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  border: 2px dashed rgba(255, 255, 255, 0.16);
  pointer-events: none;
}
.trandings-insite {
  max-width: 280px;
  width: 100%;
  text-align: left;
  padding: 0px 22px;
  transition: transform 0.3s ease;
}
.trandings-insite:hover {
  transform: translateY(-4px);
}
.tranding-headding h6 {
  font-weight: 700;
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: 0;
  color: #fff;
  margin: 0;
  text-transform: uppercase;
  text-wrap-mode: wrap;
}
.tranding-headding {
  flex: 0 0 210px;
}
.number-circle {
  width: 24px;
  height: 24px;
  margin: 0 0 12px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-weight: 700;
  font-size: 13px;
  text-align: center;
  color: var(--theme);
}
.trandings-insite h6 {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
  color: #fff;
}
section.plan-section {
  position: relative;
  padding: 50px 0px 70px;
  /* overflow:hidden removed — it breaks position:sticky on .scroll-story-visual */
}
.plan-section-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image:
    linear-gradient(rgba(7, 30, 49, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 30, 49, 0.05) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse 65% 70% at 50% 35%, #000 0%, transparent 75%);
}
.plan-section .container,
.plan-section .container-fluid {
  position: relative;
  z-index: 1;
}
.plan-header h6.subtitle { 
  font-weight: 600; 
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  margin: 0;
  color:#071E31;
}
h2.section-title {
  font-weight: 700;
  font-size: clamp(24px, 2.6vw, 32px);
  line-height: 1.4;
  text-align: center;
  color: var(--themeDark);
  margin: 0;
  margin-bottom: 22px;
}
.plan-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 18px;
}
.plan-sep {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #B9C4CE;
  flex-shrink: 0;
}
.plan-word-gradient {
  color: #3B6B94;
}
.plan-header p { 
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;
  margin: 0 auto 30px;
  color: var(--themeDark);
  max-width: 600px;
  width: 100%;

}
/* Scroll-driven story (Stripe/Linear-style): text steps scroll past on the
   left, a sticky panel on the right swaps screenshot per active step. */
.scroll-story {
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 50px;
  align-items: stretch;
  margin-top: 40px;
  padding: 0 5%;
}
/* Mobile-only per-step screenshot — hidden on desktop */
.scroll-story-step-shot {
  display: none;
}
.scroll-story-visual {
  align-self: stretch;
  max-width: 720px;
  padding-top: 14vh;
}
.scroll-story-text {
  display: flex;
  flex-direction: column;
  gap: 220px;
  padding: 14vh 0;
}
.scroll-story-step {
  opacity: 0.32;
  transition: opacity 0.4s ease;
  max-width: 340px;
}
.scroll-story-step.is-active {
  opacity: 1;
}
.scroll-story-step-index {
  display: block;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 1px;
  color: #3B6B94;
  margin-bottom: 8px;
}
.scroll-story-step h4 {
  font-weight: 700;
  font-size: 22px;
  line-height: 1.3;
  color: var(--themeDark);
  margin: 0 0 10px;
}
.scroll-story-step p {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #3F4753;
  margin: 0;
}
.scroll-story-visual .browser-frame {
  position: sticky;
  top: 100px;
}
.scroll-story-visual .browser-frame img.browser-frame-shot {
  animation: ime-tab-pane-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes ime-tab-pane-in {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .scroll-story-step,
  .scroll-story-visual .browser-frame img.browser-frame-shot {
    transition: none;
    animation: none;
    opacity: 1;
  }
}
section.features-grid-section{
  background: #071E31;
  padding: 50px 0px 60px;
}

h4.section-title,
h2.section-title.features-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 1.3;
  letter-spacing: -0.5px;
  text-align: center;
  color: #fff;
  white-space: nowrap;
  max-width: none;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.features-title-accent {
  color: #3B6B94;
}
.section-header {
  margin-bottom: 36px;
}
.section-header h6.subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  color: #fff;
}
/* Bento grid: an asymmetric tile layout (one large "hero" tile, two small
   tiles, one wide tile) reads as more designed than four equal columns. */
.feature-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: minmax(160px, auto);
}
.feature-grid-card {
  position: relative;
  overflow: hidden;
  text-align: left;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 18px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 14px;
  backdrop-filter: blur(6px);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), background 0.35s ease,
              border-color 0.35s ease, box-shadow 0.35s ease;
}
.feature-grid-card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(108, 229, 232, 0.3);
  box-shadow: 0 12px 48px rgba(108, 229, 232, 0.12), 0 4px 16px rgba(0, 0, 0, 0.25);
}
.feature-grid-card.bento-lg,
.feature-grid-card.bento-sm,
.feature-grid-card.bento-wide {
  grid-column: span 1;
  grid-row: span 1;
}
.feature-icon-container {
  width: clamp(28px, 3.2vw, 38px);
  height: clamp(28px, 3.2vw, 38px);
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
  background: rgba(59, 107, 148, 0.35);
  border-radius: 10px;
  margin: 0 0 12px;
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), background 0.35s ease;
}
.feature-icon-container .feature-icon {
  width: clamp(14px, 1.5vw, 18px);
  height: clamp(14px, 1.5vw, 18px);
}
.feature-grid-card:hover .feature-icon-container {
  transform: scale(1.08);
  background: rgba(59, 107, 148, 0.55);
}
h6.feature-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #fff;
  margin-bottom: 5px;
}
p.feature-text {
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  text-align: left;
  color: #F2F5FF;
  margin: 0;
}
.ant-collapse.faq-collapse {
  background: transparent;
}
.faq-container {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
}
.ant-collapse-item.faq-panel {
  border: 0px;
  background: transparent;
  border-bottom: 1px solid #E5E9EF;
  margin-bottom: 0;
}
.ant-collapse-header {
  color: #071E31;
  font-family: 'Greycliff CF';
  font-weight: 700;
  font-size: 15px;
  line-height: 150%;
  border: 0px;
  padding: 16px 0 !important;
}
.faq-headding h6.section-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #3B6B94;
}
h2.faq-subtitle {
  font-weight: 700;
  font-size: 24px;
  line-height: 1.4;
  color: #1D1E24;
  margin: 0;
}
.faq-headding p {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4;
  color: #1D1E24;
  margin: 0;
}
.faq-headding {
  margin-bottom: 18px;
}
section.faq-section {
  background: #fff;
  padding-top: 50px;
  margin-bottom: 36px;
}
.newsletter-card {
  background: #071E31;
  padding: 32px 28px;
  border-radius: 20px;
  position: relative;
  margin: 0 auto;
  max-width: 780px;
  box-shadow: 0 30px 60px -20px rgba(7, 30, 49, 0.5);
}
.newsletter-glow-mask {
  position: absolute;
  inset: 0;
  border-radius: 24px;
  overflow: hidden;
  z-index: 0;
}
p.newsletter-desc {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #F2F8FF;
  max-width: 520px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
h2.newsletter-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  text-align: center;
  color: #fff;
  white-space: nowrap;
  margin: 0 auto 8px;
  position: relative;
  z-index: 1;
}
.mail-icon-wrapper {
  position: relative;
  z-index: 2;
  margin: -70px auto 16px;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #071E31;
  box-shadow: 0 0 0 4px #fff, 0 16px 30px -10px rgba(7, 30, 49, 0.6);
}
.newslatter-input {
  display: flex;
  align-items: center;
  max-width: 480px;
  margin: 24px auto 0;
  width: 100%;
  position: relative;
  z-index: 1;
  height: 52px;
  background: #fff;
  border-radius: 999px;
  padding: 6px;
  box-shadow: 0 18px 34px -14px rgba(7, 30, 49, 0.45);
}
input.ant-input.input-inn {
  border: 0px !important;
  box-shadow: none !important;
  width: 100%;
  background: transparent;
  padding-left: 18px;
  font-size: 15px;
}
button.ant-btn.subcribe-btn {
  background: #1D4A6B;
  height: 40px;
  border-radius: 999px;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  padding: 0 18px;
  border: 0px !important;
  flex-shrink: 0;
  white-space: nowrap;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
button.ant-btn.subcribe-btn:hover {
  transform: translateY(-1px);
  background: #1D4A6B !important;
  color: #fff !important;
}
footer.footer-section {
  background: #071E31;
  padding: 36px 0px 22px;
}
section.newsletter-section {
  background: #fff;
  padding: 0 0 44px;
}
.footer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-bottom: 30px;
  border-bottom: 1px solid #D9D9D9;
  margin-bottom: 20px;
}
a.footer-social-btn {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
a.footer-social-btn:hover {
  opacity: 1;
}
a.footer-social-btn img {
  width: 100%;
  height: 100%;
}
.social-bar-icons {
  display: flex;
  gap: 16px;
  align-items: center;
}
.footer-dics p { 
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #fff;
}
.footer-bootamline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.trms-text-line {
  display: flex;
  gap: 24px;
}
.trms-text-line {
  align-items: center;
}
.trms-text-line a.footer-nav-link {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.2s ease;
}
.trms-text-line a.footer-nav-link:hover {
  color: #fff;
}
.copyright-text p {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  color: rgba(255, 255, 255, 0.6);
}
.header-theme {
  background: #071E31;
  color: #fff;
  padding: 20px 20px;
}
.ant-modal.theme-modal .ant-modal-content {
  padding: 0px !important;
  border-radius: 30px !important;
  overflow: hidden;
}
.ant-modal.theme-modal .ant-modal-body {
  padding: 20px !important;
}
.ant-modal.theme-modal button.ant-modal-close {
  color: #fff;
  font-weight: 800 !important;
  top: 15px !important;
}
.theme-change-outer {
  display: grid;
  gap: 15px;
}
.theme-change-outer button {
  background: #071E311A;
  padding: 15px !important;
  border-radius: 70px;
  border: 1px solid #071E311A !important;
  min-height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1D1E24 !important;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;
  gap: 16px;
  outline: none !important;
}
.theme-change-outer button:hover{
  background: #071E311A !important; 
  border: 1px solid #0a5c9f75 !important;
}
.coocies-main-modal {
  text-align: center;
  display: grid;
  gap: 18px;
}
.coocies-main-modal h6 {
  color: #10182F; 
  font-weight: 700;
  font-size: 30px;
  line-height: 30px;
  letter-spacing: 0px;
  text-align: center;
  margin: 0;
}
.coocies-main-modal p { 
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  color: #3F4753;
  margin: 0;
}
.coocies-main-modal img {
  max-width: 75px;
  width: 100%;
  margin: 0 auto;
}
.coocies-footer-modal {
  display: grid;
  gap: 10px;
}
.coocies-footer-modal button {
  width: fit-content !important;
  margin: 0 auto;
}
button.ant-btn.fill-btn{
  border: 1px solid #071E31;
  background: #071E31;
  box-shadow: 0px 14px 42px 0px #080F340F;
}

.public-blog-page {
  background: #f6f8fb;
  padding: 72px 0 96px;
  min-height: 70vh;
}

.public-blog-article {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 8px;
  padding: 48px 56px 64px;
  box-shadow: 0 18px 54px rgba(8, 15, 52, 0.08);
}

.public-blog-meta {
  color: #1563a3;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 18px;
  text-transform: uppercase;
}

.public-blog-article h1 {
  color: #071e31;
  font-size: 44px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: 0;
  margin: 0 0 28px;
}

.public-blog-cover {
  display: block;
  width: 100%;
  max-height: 480px;
  object-fit: cover;
  border-radius: 8px;
  margin: 0 0 34px;
}

.public-blog-content {
  color: #263241;
  font-size: 18px;
  line-height: 1.78;
  letter-spacing: 0;
}

.public-blog-content p {
  margin: 0 0 18px;
}

.public-blog-content img {
  max-width: 100%;
  border-radius: 8px;
}

.public-blog-content blockquote {
  border-left: 4px solid #1563a3;
  color: #3f4753;
  margin: 28px 0;
  padding-left: 18px;
}

.public-blog-state {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.public-blog-state h1 {
  color: #071e31;
  font-size: 42px;
  font-weight: 800;
  letter-spacing: 0;
  margin: 0;
}

/* ── Social Proof ── */
section.social-proof-section { padding: 100px 0; background: #F2F8FF; }
h2.section-title.social-proof-title { color: #1D1E24; white-space: normal; font-size: 40px; margin-bottom: 16px; }
.stats-row { display: flex; justify-content: center; gap: 80px; margin: 60px auto; flex-wrap: wrap; }
.stat-card { text-align: center; }
.stat-num { font-weight: 700; font-size: 52px; color: #3B6B94; }
.stat-label { font-size: 15px; color: #3F4753; margin-top: 6px; }
.testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
.testimonial-card { background: #fff; border: 1px solid rgba(7,30,49,0.08); border-radius: 20px; padding: 32px; display: flex; flex-direction: column; gap: 24px; transition: transform 0.3s ease, box-shadow 0.3s ease; }
.testimonial-card:hover { transform: translateY(-4px); box-shadow: 0 16px 40px rgba(7,30,49,0.1); }
.testimonial-quote { font-size: 15px; line-height: 1.7; color: #3F4753; margin: 0; flex: 1 1; font-style: italic; }
.testimonial-author { display: flex; align-items: center; gap: 12px; }
.testimonial-avatar { width: 44px; height: 44px; border-radius: 50%; background: #3B6B94; color: #fff; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.testimonial-name { font-weight: 700; font-size: 14px; color: #1D1E24; margin: 0; }
.testimonial-role { font-size: 12px; color: #3F4753; margin: 2px 0 0; }

/* ── Pricing ── */
section.pricing-section { padding: 100px 0; }
.pricing-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 28px; max-width: 900px; margin: 60px auto 0; }
.pricing-card { background: #F2F8FF; border: 1px solid rgba(7,30,49,0.1); border-radius: 24px; padding: 40px 36px; position: relative; display: flex; flex-direction: column; gap: 20px; }
.pricing-card-featured { background: #071E31; border-color: transparent; }
.pricing-badge { position: absolute; top: -14px; left: 50%; transform: translateX(-50%); background: #6CE5E8; color: #071E31; font-weight: 700; font-size: 12px; padding: 5px 18px; border-radius: 999px; white-space: nowrap; }
.pricing-plan-name { font-weight: 700; font-size: 20px; color: #1D1E24; margin: 0; }
.pricing-card-featured .pricing-plan-name { color: #fff; }
.pricing-price { display: flex; align-items: baseline; gap: 6px; }
.pricing-amount { font-weight: 700; font-size: 48px; color: #071E31; line-height: 1; }
.pricing-card-featured .pricing-amount { color: #fff; }
.pricing-period { font-size: 14px; color: #3F4753; }
.pricing-card-featured .pricing-period { color: rgba(255,255,255,0.65); }
.pricing-desc { font-size: 14px; color: #3F4753; line-height: 1.6; margin: 0; }
.pricing-card-featured .pricing-desc { color: rgba(255,255,255,0.75); }
.pricing-features { list-style: none !important; padding: 0 !important; margin: 0 !important; display: flex; flex-direction: column; gap: 10px; flex: 1 1; }
.pricing-features li { font-size: 14px; color: #3F4753; padding-left: 22px; position: relative; }
.pricing-features li::before { content: '✓'; position: absolute; left: 0; color: #3B6B94; font-weight: 700; }
.pricing-card-featured .pricing-features li { color: rgba(255,255,255,0.85); }
.pricing-card-featured .pricing-features li::before { color: #6CE5E8; }
button.ant-btn.pricing-cta-btn { width: 100% !important; max-width: 100% !important; margin-top: 8px; }
button.ant-btn.pricing-demo-btn { background: rgba(255,255,255,0.15) !important; color: #fff !important; border: 1px solid rgba(255,255,255,0.3) !important; }
button.ant-btn.pricing-demo-btn:hover { background: rgba(255,255,255,0.25) !important; }

/* ── Scroll-to-top ── */
.scroll-to-top-btn { position: fixed; bottom: 32px; right: 32px; width: 48px; height: 48px; border-radius: 50%; background: #071E31; color: #fff; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 999; opacity: 0; transform: translateY(16px); transition: opacity 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; pointer-events: none; box-shadow: 0 8px 20px rgba(7,30,49,0.3); }
.scroll-to-top-btn.visible { opacity: 1; transform: translateY(0); pointer-events: auto; }
.scroll-to-top-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 24px rgba(7,30,49,0.4); }
.scroll-to-top-btn svg { width: 20px; height: 20px; }

/* ── Footer nav ── */
.footer-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 44px; padding-bottom: 22px; border-bottom: 1px solid rgba(255,255,255,0.15); margin-bottom: 18px; flex-wrap: wrap; }
.footer-brand { flex: 1 1; max-width: 380px; display: flex; flex-direction: column; }
.footer-logo { height: 26px; width: auto; margin-bottom: 12px; display: block; align-self: flex-start; }
.footer-brand-desc { font-size: 12px; line-height: 1.6; color: rgba(255,255,255,0.7); margin-bottom: 12px; text-align: justify; }
.footer-nav { display: flex; gap: 44px; flex-shrink: 0; }
.footer-nav-col { display: flex; flex-direction: column; gap: 9px; }
.footer-nav-title { font-weight: 700; font-size: 11px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 2px; }
a.footer-nav-link { font-size: 13px; color: rgba(255,255,255,0.75); text-decoration: none; transition: color 0.2s ease; }
a.footer-nav-link:hover { color: #6CE5E8; }
.footer-bottom { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; }
.trms-text-line { display: flex; gap: 20px; }
.copyright-text p { font-size: 12px; color: rgba(255,255,255,0.5); margin: 0; }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2DAAyD;EACzD,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,2DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,2DAA8D;EAC9D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2DAAyD;EACzD,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;EAWE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,UAAU;EACV,2BAA2B;EAC3B,oGAAoG;AACtG;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+GAA+G;AACjH;AACA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,kDAAkD;EAClD,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,yFAAyF;AACzF;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,UAAU;EACV,sCAAsC;EACtC,oBAAoB;EACpB,sGAAsG;AACxG;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,yFAAyF;EACzF,uCAAuC;AACzC;AACA;EACE,mBAAmB,6BAA6B,EAAE,0BAA0B,EAAE;AAChF;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;sEAEoE;EACpE,0BAA0B;EAE1B,iFAAiF;AACnF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kDAAkD;AACpD;AACA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;AACtC;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;oCACoC;AACpC;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oFAAoF;EACpF,8EAA8E;AAChF;AACA;;EAEE,2BAA2B;EAC3B,mFAAmF;AACrF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E,uDAAuD,mBAAmB,EAAE;AAC5E;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sEAAsE;EACtE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;EACnD,gGAAgG;AAClG;AACA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,gFAAgF;AAClF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gGAAgG;EAChG,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2FAA2F;AAC7F;AACA,wCAAwC,UAAU,EAAE;AACpD;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gFAAgF;AAClF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;sEAEoE;EACpE,0BAA0B;EAE1B,iFAAiF;AACnF;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;;AAEb;AACA;wEACwE;AACxE;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA,wDAAwD;AACxD;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,kEAAkE;AACpE;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE;;IAEE,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;0EAC0E;AAC1E;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;EAC1B;4DAC0D;AAC5D;AACA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;EACtC,iFAAiF;AACnF;AACA;;;EAGE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kEAAkE;AACpE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,uBAAuB;AACvB,+BAA+B,gBAAgB,EAAE,mBAAmB,EAAE;AACtE,sCAAsC,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACjH,aAAa,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACpG,aAAa,kBAAkB,EAAE;AACjC,YAAY,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AAC/D,cAAc,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAChE,qBAAqB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AACtF,oBAAoB,gBAAgB,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,qDAAqD,EAAE;AACzN,0BAA0B,2BAA2B,EAAE,yCAAyC,EAAE;AAClG,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE,SAAO,EAAE,kBAAkB,EAAE;AAChH,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACrE,sBAAsB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACvN,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE;AAClF,oBAAoB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEtE,kBAAkB;AAClB,0BAA0B,gBAAgB,EAAE;AAC5C,gBAAgB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACxH,gBAAgB,mBAAmB,EAAE,mCAAmC,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACzL,yBAAyB,mBAAmB,EAAE,yBAAyB,EAAE;AACzE,iBAAiB,kBAAkB,EAAE,UAAU,EAAE,SAAS,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AAC/N,qBAAqB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE;AACnF,4CAA4C,WAAW,EAAE;AACzD,iBAAiB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AACjE,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE;AACrF,yCAAyC,WAAW,EAAE;AACtD,kBAAkB,eAAe,EAAE,cAAc,EAAE;AACnD,yCAAyC,6BAA6B,EAAE;AACxE,gBAAgB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC9E,uCAAuC,6BAA6B,EAAE;AACtE,oBAAoB,2BAA2B,EAAE,qBAAqB,EAAE,oBAAoB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,SAAO,EAAE;AACzJ,uBAAuB,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAChG,+BAA+B,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC5G,8CAA8C,6BAA6B,EAAE;AAC7E,sDAAsD,cAAc,EAAE;AACtE,iCAAiC,sBAAsB,EAAE,0BAA0B,EAAE,eAAe,EAAE;AACtG,kCAAkC,6CAA6C,EAAE,sBAAsB,EAAE,kDAAkD,EAAE;AAC7J,wCAAwC,6CAA6C,EAAE;;AAEvF,wBAAwB;AACxB,qBAAqB,eAAe,EAAE,YAAY,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,UAAU,EAAE,2BAA2B,EAAE,wEAAwE,EAAE,oBAAoB,EAAE,wCAAwC,EAAE;AAC/a,6BAA6B,UAAU,EAAE,wBAAwB,EAAE,oBAAoB,EAAE;AACzF,2BAA2B,2BAA2B,EAAE,yCAAyC,EAAE;AACnG,yBAAyB,WAAW,EAAE,YAAY,EAAE;;AAEpD,qBAAqB;AACrB,cAAc,aAAa,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,SAAS,EAAE,oBAAoB,EAAE,+CAA+C,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC9M,gBAAgB,SAAO,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAClF,eAAe,YAAY,EAAE,WAAW,EAAE,mBAAmB,EAAE,cAAc,EAAE,sBAAsB,EAAE;AACvG,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAChI,cAAc,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE;AACxD,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE,oBAAoB,gBAAgB,EAAE,eAAe,EAAE,4BAA4B,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACzJ,oBAAoB,eAAe,EAAE,6BAA6B,EAAE,qBAAqB,EAAE,2BAA2B,EAAE;AACxH,0BAA0B,cAAc,EAAE;AAC1C,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE;AACjH,kBAAkB,aAAa,EAAE,SAAS,EAAE;AAC5C,oBAAoB,eAAe,EAAE,4BAA4B,EAAE,SAAS,EAAE","sourcesContent":[":root {\n  --theme: #071E31;\n  --themeDark: #1D1E24;\n  --themelight: #ffffff;\n  --themeSuccess: #16c748;\n  --themeDanger: #ff3030; \n}\n\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Bold.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Visby Round CF Demi';\n  src: url('../fonts/GreycliffCF-DemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Visby Round CF Extra';\n  src: url('../fonts/GreycliffCF-ExtraBold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Bold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\nbody {\n  font-family: 'Greycliff CF' !important;\n  width: 100% !important;\n  margin: 0;\n  padding: 0;\n  background-color: #fff !important;\n}\n.imergey-layout {\n  background: #fff;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nspan,\n*,\na {\n  font-family: 'Greycliff CF' !important;\n}\n\nul {\n  padding: 0px !important;\n  margin: 0px !important;\n  list-style: none;\n}\n\n/* Scroll-reveal (used by the <Reveal> wrapper on the homepage) */\n.reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n.reveal-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n@media (prefers-reduced-motion: reduce) {\n  .reveal {\n    transition: none;\n    opacity: 1;\n    transform: none;\n  }\n}\n \nnav.header-main {\n  background: #F2F8FF;\n  padding: 10px 30px;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid transparent;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease, backdrop-filter 0.3s ease, border-color 0.3s ease;\n}\nnav.header-main.header-main-scrolled {\n  background: rgba(242, 248, 255, 0.72);\n  backdrop-filter: blur(14px) saturate(160%);\n  -webkit-backdrop-filter: blur(14px) saturate(160%);\n  box-shadow: 0 8px 28px -12px rgba(7, 30, 49, 0.18);\n  border-bottom-color: rgba(7, 30, 49, 0.06);\n}\n.logo-image img {\n  height: 38px;\n  width: auto;\n  display: block;\n}\n\n/* ── sticky mini \"Book a Demo\" CTA — fades/slides in once the hero is scrolled past ── */\n.header-mini-cta {\n  margin-left: 22px;\n  flex-shrink: 0;\n  align-items: center;\n  background: linear-gradient(135deg, #071E31 0%, #3B6B94 100%);\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1;\n  border: none;\n  border-radius: 999px;\n  padding: 10px 20px;\n  cursor: pointer;\n  box-shadow: 0 8px 20px -8px rgba(7, 30, 49, 0.5);\n  opacity: 0;\n  transform: translateY(-8px) scale(0.9);\n  pointer-events: none;\n  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;\n}\n.header-mini-cta.header-mini-cta-in {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n.header-mini-cta:hover {\n  box-shadow: 0 12px 26px -8px rgba(59, 107, 148, 0.6), 0 0 0 3px rgba(108, 229, 232, 0.18);\n  transform: translateY(-1px) scale(1.02);\n}\n@media (prefers-reduced-motion: reduce) {\n  .header-mini-cta { transition: opacity 0.2s ease; transform: none !important; }\n}\nbutton.menu-toggle svg {\n  width: 40px;\n  height: 40px;\n}\nbutton.menu-toggle {\n  width: 40px;\n  padding: 0px;\n  height: auto;\n}\n.mobile-menu.nav {\n  gap: 16px;\n  text-align: left !important;\n}\n.mobile-menu.nav a.menu-link.nav-link { \n  padding: 10px !important;  \n  border-bottom: 1px solid #cccccc61;\n}\n.mobile-menu.nav a.menu-link.active {\n  font-weight: 700;\n  background-color: #071E31;\n  color: #fff !important;\n}\n.ant-drawer-content.mobile-menu-drawer .ant-drawer-header.ant-drawer-header-close-only {\n  background-color: #3B6B94;\n}\n.ant-drawer-content.mobile-menu-drawer button.ant-drawer-close {\n  color: #fff !important;\n  font-size: 22px !important;\n}\n#whoweare, #whatwedo, #howitwork, #insights, #faq {\n  scroll-margin-top: 50px;\n}\n.ant-drawer-content-wrapper {\n  top: 60px !important;\n}\na.menu-link.nav-link {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 100%;\n  color: #071E31 !important;\n  padding: 0px !important;\n}\na.menu-link.active  {\n  font-weight: 700;\n}\n.navbar-menu.navbar-nav {\n  gap: 20px;\n}\nbutton.ant-btn.fill-btn {\n  background: #3B6B94;\n  min-width: 130px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 100%;\n  min-height: 38px;\n  border: 1px solid #3B6B94;\n  border-radius: 8px;\n}\nbutton.ant-btn.outline-btn {\n  background: transparent;\n  min-width: 130px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--themeDark);\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 100%;\n  min-height: 38px;\n  border-radius: 8px;\n  border:  1px solid #071E311A;\n}\n.header-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\nsection.hero-section {\n  padding: 56px 0px 32px;\n  position: relative;\n  overflow: hidden;\n}\n.hero-grid-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background-image:\n    linear-gradient(rgba(7, 30, 49, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(7, 30, 49, 0.05) 1px, transparent 1px);\n  background-size: 42px 42px;\n  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 30%, #000 0%, transparent 75%);\n  mask-image: radial-gradient(ellipse 70% 60% at 50% 30%, #000 0%, transparent 75%);\n}\nsection.hero-section .hero-banner-shape {\n  position: absolute;\n  right: 0;\n  bottom: 35%;\n  z-index: 0;\n}\n.hero-banner-shape img{\n  max-width: 450px;\n  width: 100%;\n  animation: ime-float-shape 6s ease-in-out infinite;\n}\n@keyframes ime-float-shape {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-18px); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .hero-banner-shape img {\n    animation: none;\n  }\n}\nh1.hero-title {\n  font-weight: 700;\n  font-size: clamp(28px, 3.4vw, 40px);\n  line-height: 1.4;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--themeDark);\n  margin: 0;\n}\nh1.hero-title span{\n  color: #3B6B94;\n}\np.hero-subtitle {\n  color: var(--themeDark);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.4;\n  margin: 0;\n  letter-spacing: 0%;\n  text-align: center;\n}\n.platform-preview {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 20px auto;\n  position: relative;\n}\n.platform-preview .browser-frame {\n  max-width: 660px;\n}\n\n/* Real product screenshots, framed as a browser window so it's obvious\n   these aren't stock photography. */\n.browser-frame {\n  width: 100%;\n  margin: 0 auto;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 30px 60px -20px rgba(7, 30, 49, 0.35), 0 0 0 1px rgba(7, 30, 49, 0.06);\n  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease;\n}\n.platform-preview .browser-frame:hover,\n.dashboard-preview .browser-frame:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 40px 70px -20px rgba(7, 30, 49, 0.4), 0 0 0 1px rgba(7, 30, 49, 0.06);\n}\n.browser-frame .browser-frame-bar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 10px 16px;\n  background: #EEF2F7;\n  border-bottom: 1px solid #E1E7EF;\n}\n.browser-frame .browser-frame-dots {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n}\n.browser-frame .browser-frame-dots span {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: block;\n}\n.browser-frame .browser-frame-dots span:nth-child(1) { background: #FF5F57; }\n.browser-frame .browser-frame-dots span:nth-child(2) { background: #FEBC2E; }\n.browser-frame .browser-frame-dots span:nth-child(3) { background: #28C840; }\n.browser-frame .browser-frame-url {\n  flex: 1;\n  max-width: 320px;\n  margin: 0 auto;\n  background: #E8EDF3;\n  border: 1px solid #D8DFE8;\n  border-radius: 20px;\n  padding: 5px 14px;\n  font-size: 12px;\n  color: #9BA8B5;\n  text-align: center;\n  font-weight: 400;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  letter-spacing: 0.01em;\n}\n.browser-frame img.browser-frame-shot {\n  display: block;\n  width: 100%;\n}\n.hero-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\nbutton.ant-btn.trial-btn {\n  background: #071E31;\n  max-width: 300px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 100%;\n  min-height: 50px;\n  border: 1px solid #071E31;\n  border-radius: 8px;\n  box-shadow: 0 14px 30px -10px rgba(7, 30, 49, 0.55);\n  transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease, color 0.25s ease;\n}\nbutton.ant-btn.trial-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 34px -10px rgba(7, 30, 49, 0.4);\n}\nbutton.ant-btn.trial-btn:hover  , button.ant-btn.fill-btn:hover{\n  background: #fff !important;\n  color: #071E31 !important;\n  border: 1px solid #071E31 !important;\n}\nbutton.ant-btn.outline-btn:hover {\n  background: #fff !important;\n  color: #071E31 !important;\n  border: 1px solid #071E31 !important;\n}\n\nbutton.ant-btn.demo-btn {\n  background: linear-gradient(180deg, #ffffff 0%, #f4f9fc 100%);\n  max-width: 300px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 9px;\n  color: #071E31;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 100%;\n  min-height: 50px;\n  border: 2px solid #3B6B94;\n  border-radius: 8px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 10px 26px -14px rgba(59, 107, 148, 0.6);\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\nbutton.ant-btn.demo-btn::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(120deg, rgba(108, 229, 232, 0.22) 0%, rgba(59, 107, 148, 0.06) 100%);\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\nbutton.ant-btn.demo-btn .demo-btn-icon {\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n}\nbutton.ant-btn.demo-btn span:not(.demo-btn-icon) {\n  position: relative;\n}\nbutton.ant-btn.demo-btn:hover {\n  transform: translateY(-2px);\n  border-color: #6CE5E8;\n  box-shadow: 0 18px 36px -12px rgba(59, 107, 148, 0.55), 0 0 0 4px rgba(108, 229, 232, 0.14);\n}\nbutton.ant-btn.demo-btn:hover::before { opacity: 1; }\n.features-container {\n  background: var(--theme);\n  border-radius: 16px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 36px 44px;\n  margin-top: 70px;\n  position: relative;\n  overflow: hidden;\n}\n.features-container::after {\n  content: '';\n  position: absolute;\n  right: -90px;\n  bottom: -160px;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  border: 2px dashed rgba(255, 255, 255, 0.16);\n  pointer-events: none;\n}\n.trandings-insite {\n  max-width: 280px;\n  width: 100%;\n  text-align: left;\n  padding: 0px 22px;\n  transition: transform 0.3s ease;\n}\n.trandings-insite:hover {\n  transform: translateY(-4px);\n}\n.tranding-headding h6 {\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.3;\n  letter-spacing: 0;\n  color: #fff;\n  margin: 0;\n  text-transform: uppercase;\n  text-wrap-mode: wrap;\n}\n.tranding-headding {\n  flex: 0 0 210px;\n}\n.number-circle {\n  width: 24px;\n  height: 24px;\n  margin: 0 0 12px;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  font-weight: 700;\n  font-size: 13px;\n  text-align: center;\n  color: var(--theme);\n}\n.trandings-insite h6 {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.4;\n  text-align: left;\n  color: #fff;\n}\nsection.plan-section {\n  position: relative;\n  padding: 50px 0px 70px;\n  /* overflow:hidden removed — it breaks position:sticky on .scroll-story-visual */\n}\n.plan-section-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background-image:\n    linear-gradient(rgba(7, 30, 49, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(7, 30, 49, 0.05) 1px, transparent 1px);\n  background-size: 42px 42px;\n  -webkit-mask-image: radial-gradient(ellipse 65% 70% at 50% 35%, #000 0%, transparent 75%);\n  mask-image: radial-gradient(ellipse 65% 70% at 50% 35%, #000 0%, transparent 75%);\n}\n.plan-section .container,\n.plan-section .container-fluid {\n  position: relative;\n  z-index: 1;\n}\n.plan-header h6.subtitle { \n  font-weight: 600; \n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0;\n  text-align: center;\n  margin: 0;\n  color:#071E31;\n}\nh2.section-title {\n  font-weight: 700;\n  font-size: clamp(24px, 2.6vw, 32px);\n  line-height: 1.4;\n  text-align: center;\n  color: var(--themeDark);\n  margin: 0;\n  margin-bottom: 22px;\n}\n.plan-title {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 18px;\n}\n.plan-sep {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #B9C4CE;\n  flex-shrink: 0;\n}\n.plan-word-gradient {\n  color: #3B6B94;\n}\n.plan-header p { \n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.4;\n  text-align: center;\n  margin: 0 auto 30px;\n  color: var(--themeDark);\n  max-width: 600px;\n  width: 100%;\n\n}\n/* Scroll-driven story (Stripe/Linear-style): text steps scroll past on the\n   left, a sticky panel on the right swaps screenshot per active step. */\n.scroll-story {\n  display: grid;\n  grid-template-columns: 0.85fr 1.15fr;\n  gap: 50px;\n  align-items: stretch;\n  margin-top: 40px;\n  padding: 0 5%;\n}\n/* Mobile-only per-step screenshot — hidden on desktop */\n.scroll-story-step-shot {\n  display: none;\n}\n.scroll-story-visual {\n  align-self: stretch;\n  max-width: 720px;\n  padding-top: 14vh;\n}\n.scroll-story-text {\n  display: flex;\n  flex-direction: column;\n  gap: 220px;\n  padding: 14vh 0;\n}\n.scroll-story-step {\n  opacity: 0.32;\n  transition: opacity 0.4s ease;\n  max-width: 340px;\n}\n.scroll-story-step.is-active {\n  opacity: 1;\n}\n.scroll-story-step-index {\n  display: block;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 1px;\n  color: #3B6B94;\n  margin-bottom: 8px;\n}\n.scroll-story-step h4 {\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.3;\n  color: var(--themeDark);\n  margin: 0 0 10px;\n}\n.scroll-story-step p {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #3F4753;\n  margin: 0;\n}\n.scroll-story-visual .browser-frame {\n  position: sticky;\n  top: 100px;\n}\n.scroll-story-visual .browser-frame img.browser-frame-shot {\n  animation: ime-tab-pane-in 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n@keyframes ime-tab-pane-in {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .scroll-story-step,\n  .scroll-story-visual .browser-frame img.browser-frame-shot {\n    transition: none;\n    animation: none;\n    opacity: 1;\n  }\n}\nsection.features-grid-section{\n  background: #071E31;\n  padding: 50px 0px 60px;\n}\n\nh4.section-title,\nh2.section-title.features-title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.3;\n  letter-spacing: -0.5px;\n  text-align: center;\n  color: #fff;\n  white-space: nowrap;\n  max-width: none;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 20px;\n}\n.features-title-accent {\n  color: #3B6B94;\n}\n.section-header {\n  margin-bottom: 36px;\n}\n.section-header h6.subtitle {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: center;\n  color: #fff;\n}\n/* Bento grid: an asymmetric tile layout (one large \"hero\" tile, two small\n   tiles, one wide tile) reads as more designed than four equal columns. */\n.feature-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: minmax(160px, auto);\n}\n.feature-grid-card {\n  position: relative;\n  overflow: hidden;\n  text-align: left;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 14px;\n  backdrop-filter: blur(6px);\n  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), background 0.35s ease,\n              border-color 0.35s ease, box-shadow 0.35s ease;\n}\n.feature-grid-card:hover {\n  transform: translateY(-6px);\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(108, 229, 232, 0.3);\n  box-shadow: 0 12px 48px rgba(108, 229, 232, 0.12), 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n.feature-grid-card.bento-lg,\n.feature-grid-card.bento-sm,\n.feature-grid-card.bento-wide {\n  grid-column: span 1;\n  grid-row: span 1;\n}\n.feature-icon-container {\n  width: clamp(28px, 3.2vw, 38px);\n  height: clamp(28px, 3.2vw, 38px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(5px);\n  background: rgba(59, 107, 148, 0.35);\n  border-radius: 10px;\n  margin: 0 0 12px;\n  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), background 0.35s ease;\n}\n.feature-icon-container .feature-icon {\n  width: clamp(14px, 1.5vw, 18px);\n  height: clamp(14px, 1.5vw, 18px);\n}\n.feature-grid-card:hover .feature-icon-container {\n  transform: scale(1.08);\n  background: rgba(59, 107, 148, 0.55);\n}\nh6.feature-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 140%;\n  color: #fff;\n  margin-bottom: 5px;\n}\np.feature-text {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 150%;\n  text-align: left;\n  color: #F2F5FF;\n  margin: 0;\n}\n.ant-collapse.faq-collapse {\n  background: transparent;\n}\n.faq-container {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n}\n.ant-collapse-item.faq-panel {\n  border: 0px;\n  background: transparent;\n  border-bottom: 1px solid #E5E9EF;\n  margin-bottom: 0;\n}\n.ant-collapse-header {\n  color: #071E31;\n  font-family: 'Greycliff CF';\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 150%;\n  border: 0px;\n  padding: 16px 0 !important;\n}\n.faq-headding h6.section-title {\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #3B6B94;\n}\nh2.faq-subtitle {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 1.4;\n  color: #1D1E24;\n  margin: 0;\n}\n.faq-headding p {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #1D1E24;\n  margin: 0;\n}\n.faq-headding {\n  margin-bottom: 18px;\n}\nsection.faq-section {\n  background: #fff;\n  padding-top: 50px;\n  margin-bottom: 36px;\n}\n.newsletter-card {\n  background: #071E31;\n  padding: 32px 28px;\n  border-radius: 20px;\n  position: relative;\n  margin: 0 auto;\n  max-width: 780px;\n  box-shadow: 0 30px 60px -20px rgba(7, 30, 49, 0.5);\n}\n.newsletter-glow-mask {\n  position: absolute;\n  inset: 0;\n  border-radius: 24px;\n  overflow: hidden;\n  z-index: 0;\n}\np.newsletter-desc {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #F2F8FF;\n  max-width: 520px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\nh2.newsletter-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 1.3;\n  text-align: center;\n  color: #fff;\n  white-space: nowrap;\n  margin: 0 auto 8px;\n  position: relative;\n  z-index: 1;\n}\n.mail-icon-wrapper {\n  position: relative;\n  z-index: 2;\n  margin: -70px auto 16px;\n  width: 46px;\n  height: 46px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #071E31;\n  box-shadow: 0 0 0 4px #fff, 0 16px 30px -10px rgba(7, 30, 49, 0.6);\n}\n.newslatter-input {\n  display: flex;\n  align-items: center;\n  max-width: 480px;\n  margin: 24px auto 0;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n  height: 52px;\n  background: #fff;\n  border-radius: 999px;\n  padding: 6px;\n  box-shadow: 0 18px 34px -14px rgba(7, 30, 49, 0.45);\n}\ninput.ant-input.input-inn {\n  border: 0px !important;\n  box-shadow: none !important;\n  width: 100%;\n  background: transparent;\n  padding-left: 18px;\n  font-size: 15px;\n}\nbutton.ant-btn.subcribe-btn {\n  background: #1D4A6B;\n  height: 40px;\n  border-radius: 999px;\n  color: #fff;\n  font-weight: 700;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: center;\n  padding: 0 18px;\n  border: 0px !important;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\nbutton.ant-btn.subcribe-btn:hover {\n  transform: translateY(-1px);\n  background: #1D4A6B !important;\n  color: #fff !important;\n}\nfooter.footer-section {\n  background: #071E31;\n  padding: 36px 0px 22px;\n}\nsection.newsletter-section {\n  background: #fff;\n  padding: 0 0 44px;\n}\n.footer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 30px;\n  border-bottom: 1px solid #D9D9D9;\n  margin-bottom: 20px;\n}\na.footer-social-btn {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: transparent;\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n}\na.footer-social-btn:hover {\n  opacity: 1;\n}\na.footer-social-btn img {\n  width: 100%;\n  height: 100%;\n}\n.social-bar-icons {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n.footer-dics p { \n  font-weight: 400;\n  font-size: 16px;\n  line-height: 32px;\n  color: #fff;\n}\n.footer-bootamline {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.trms-text-line {\n  display: flex;\n  gap: 24px;\n}\n.trms-text-line {\n  align-items: center;\n}\n.trms-text-line a.footer-nav-link {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.6);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.trms-text-line a.footer-nav-link:hover {\n  color: #fff;\n}\n.copyright-text p {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.6);\n}\n.header-theme {\n  background: #071E31;\n  color: #fff;\n  padding: 20px 20px;\n}\n.ant-modal.theme-modal .ant-modal-content {\n  padding: 0px !important;\n  border-radius: 30px !important;\n  overflow: hidden;\n}\n.ant-modal.theme-modal .ant-modal-body {\n  padding: 20px !important;\n}\n.ant-modal.theme-modal button.ant-modal-close {\n  color: #fff;\n  font-weight: 800 !important;\n  top: 15px !important;\n}\n.theme-change-outer {\n  display: grid;\n  gap: 15px;\n}\n.theme-change-outer button {\n  background: #071E311A;\n  padding: 15px !important;\n  border-radius: 70px;\n  border: 1px solid #071E311A !important;\n  min-height: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #1D1E24 !important;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0;\n  gap: 16px;\n  outline: none !important;\n}\n.theme-change-outer button:hover{\n  background: #071E311A !important; \n  border: 1px solid #0a5c9f75 !important;\n}\n.coocies-main-modal {\n  text-align: center;\n  display: grid;\n  gap: 18px;\n}\n.coocies-main-modal h6 {\n  color: #10182F; \n  font-weight: 700;\n  font-size: 30px;\n  line-height: 30px;\n  letter-spacing: 0px;\n  text-align: center;\n  margin: 0;\n}\n.coocies-main-modal p { \n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0;\n  text-align: center;\n  color: #3F4753;\n  margin: 0;\n}\n.coocies-main-modal img {\n  max-width: 75px;\n  width: 100%;\n  margin: 0 auto;\n}\n.coocies-footer-modal {\n  display: grid;\n  gap: 10px;\n}\n.coocies-footer-modal button {\n  width: fit-content !important;\n  margin: 0 auto;\n}\nbutton.ant-btn.fill-btn{\n  border: 1px solid #071E31;\n  background: #071E31;\n  box-shadow: 0px 14px 42px 0px #080F340F;\n}\n\n.public-blog-page {\n  background: #f6f8fb;\n  padding: 72px 0 96px;\n  min-height: 70vh;\n}\n\n.public-blog-article {\n  max-width: 900px;\n  margin: 0 auto;\n  background: #fff;\n  border: 1px solid #e6ebf1;\n  border-radius: 8px;\n  padding: 48px 56px 64px;\n  box-shadow: 0 18px 54px rgba(8, 15, 52, 0.08);\n}\n\n.public-blog-meta {\n  color: #1563a3;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0;\n  margin-bottom: 18px;\n  text-transform: uppercase;\n}\n\n.public-blog-article h1 {\n  color: #071e31;\n  font-size: 44px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: 0;\n  margin: 0 0 28px;\n}\n\n.public-blog-cover {\n  display: block;\n  width: 100%;\n  max-height: 480px;\n  object-fit: cover;\n  border-radius: 8px;\n  margin: 0 0 34px;\n}\n\n.public-blog-content {\n  color: #263241;\n  font-size: 18px;\n  line-height: 1.78;\n  letter-spacing: 0;\n}\n\n.public-blog-content p {\n  margin: 0 0 18px;\n}\n\n.public-blog-content img {\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n.public-blog-content blockquote {\n  border-left: 4px solid #1563a3;\n  color: #3f4753;\n  margin: 28px 0;\n  padding-left: 18px;\n}\n\n.public-blog-state {\n  min-height: 360px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.public-blog-state h1 {\n  color: #071e31;\n  font-size: 42px;\n  font-weight: 800;\n  letter-spacing: 0;\n  margin: 0;\n}\n\n/* ── Social Proof ── */\nsection.social-proof-section { padding: 100px 0; background: #F2F8FF; }\nh2.section-title.social-proof-title { color: #1D1E24; white-space: normal; font-size: 40px; margin-bottom: 16px; }\n.stats-row { display: flex; justify-content: center; gap: 80px; margin: 60px auto; flex-wrap: wrap; }\n.stat-card { text-align: center; }\n.stat-num { font-weight: 700; font-size: 52px; color: #3B6B94; }\n.stat-label { font-size: 15px; color: #3F4753; margin-top: 6px; }\n.testimonials-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }\n.testimonial-card { background: #fff; border: 1px solid rgba(7,30,49,0.08); border-radius: 20px; padding: 32px; display: flex; flex-direction: column; gap: 24px; transition: transform 0.3s ease, box-shadow 0.3s ease; }\n.testimonial-card:hover { transform: translateY(-4px); box-shadow: 0 16px 40px rgba(7,30,49,0.1); }\n.testimonial-quote { font-size: 15px; line-height: 1.7; color: #3F4753; margin: 0; flex: 1; font-style: italic; }\n.testimonial-author { display: flex; align-items: center; gap: 12px; }\n.testimonial-avatar { width: 44px; height: 44px; border-radius: 50%; background: #3B6B94; color: #fff; font-weight: 700; font-size: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }\n.testimonial-name { font-weight: 700; font-size: 14px; color: #1D1E24; margin: 0; }\n.testimonial-role { font-size: 12px; color: #3F4753; margin: 2px 0 0; }\n\n/* ── Pricing ── */\nsection.pricing-section { padding: 100px 0; }\n.pricing-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 28px; max-width: 900px; margin: 60px auto 0; }\n.pricing-card { background: #F2F8FF; border: 1px solid rgba(7,30,49,0.1); border-radius: 24px; padding: 40px 36px; position: relative; display: flex; flex-direction: column; gap: 20px; }\n.pricing-card-featured { background: #071E31; border-color: transparent; }\n.pricing-badge { position: absolute; top: -14px; left: 50%; transform: translateX(-50%); background: #6CE5E8; color: #071E31; font-weight: 700; font-size: 12px; padding: 5px 18px; border-radius: 999px; white-space: nowrap; }\n.pricing-plan-name { font-weight: 700; font-size: 20px; color: #1D1E24; margin: 0; }\n.pricing-card-featured .pricing-plan-name { color: #fff; }\n.pricing-price { display: flex; align-items: baseline; gap: 6px; }\n.pricing-amount { font-weight: 700; font-size: 48px; color: #071E31; line-height: 1; }\n.pricing-card-featured .pricing-amount { color: #fff; }\n.pricing-period { font-size: 14px; color: #3F4753; }\n.pricing-card-featured .pricing-period { color: rgba(255,255,255,0.65); }\n.pricing-desc { font-size: 14px; color: #3F4753; line-height: 1.6; margin: 0; }\n.pricing-card-featured .pricing-desc { color: rgba(255,255,255,0.75); }\n.pricing-features { list-style: none !important; padding: 0 !important; margin: 0 !important; display: flex; flex-direction: column; gap: 10px; flex: 1; }\n.pricing-features li { font-size: 14px; color: #3F4753; padding-left: 22px; position: relative; }\n.pricing-features li::before { content: '✓'; position: absolute; left: 0; color: #3B6B94; font-weight: 700; }\n.pricing-card-featured .pricing-features li { color: rgba(255,255,255,0.85); }\n.pricing-card-featured .pricing-features li::before { color: #6CE5E8; }\nbutton.ant-btn.pricing-cta-btn { width: 100% !important; max-width: 100% !important; margin-top: 8px; }\nbutton.ant-btn.pricing-demo-btn { background: rgba(255,255,255,0.15) !important; color: #fff !important; border: 1px solid rgba(255,255,255,0.3) !important; }\nbutton.ant-btn.pricing-demo-btn:hover { background: rgba(255,255,255,0.25) !important; }\n\n/* ── Scroll-to-top ── */\n.scroll-to-top-btn { position: fixed; bottom: 32px; right: 32px; width: 48px; height: 48px; border-radius: 50%; background: #071E31; color: #fff; border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 999; opacity: 0; transform: translateY(16px); transition: opacity 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; pointer-events: none; box-shadow: 0 8px 20px rgba(7,30,49,0.3); }\n.scroll-to-top-btn.visible { opacity: 1; transform: translateY(0); pointer-events: auto; }\n.scroll-to-top-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 24px rgba(7,30,49,0.4); }\n.scroll-to-top-btn svg { width: 20px; height: 20px; }\n\n/* ── Footer nav ── */\n.footer-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 44px; padding-bottom: 22px; border-bottom: 1px solid rgba(255,255,255,0.15); margin-bottom: 18px; flex-wrap: wrap; }\n.footer-brand { flex: 1; max-width: 380px; display: flex; flex-direction: column; }\n.footer-logo { height: 26px; width: auto; margin-bottom: 12px; display: block; align-self: flex-start; }\n.footer-brand-desc { font-size: 12px; line-height: 1.6; color: rgba(255,255,255,0.7); margin-bottom: 12px; text-align: justify; }\n.footer-nav { display: flex; gap: 44px; flex-shrink: 0; }\n.footer-nav-col { display: flex; flex-direction: column; gap: 9px; }\n.footer-nav-title { font-weight: 700; font-size: 11px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 2px; }\na.footer-nav-link { font-size: 13px; color: rgba(255,255,255,0.75); text-decoration: none; transition: color 0.2s ease; }\na.footer-nav-link:hover { color: #6CE5E8; }\n.footer-bottom { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; }\n.trms-text-line { display: flex; gap: 20px; }\n.copyright-text p { font-size: 12px; color: rgba(255,255,255,0.5); margin: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
